<script>
import {lang} from "../store.js"
</script>

<style>
.aboutMe{
    display:flex;
    justify-content: center;
    align-items: flex-start;
    padding: 80px 0;
    color: white;
    position: relative;
}
.title
{
    margin: 0px 150px 0 0;
}
.content p{
font-size: 22px;
max-width: 750px;
}
.title h1{
font-size: 60px;
margin: 0;
font-weight: 800;
}
ul{
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    max-height: 180px;
    font-size: 18px;
    font-weight: 600;
}
li{
    list-style: none;
    display: flex;
    align-items: center;

}
ul li::before {
  content: "\2022";
  color: var(--primary);
  font-weight: bold;
  display: inline-block; 
  width: 1em;
  margin-left: -1em;
  font-size: 35px;
}
.p1,.p2{
    position: absolute;
    filter: invert(9%) sepia(100%) saturate(5593%) hue-rotate(335deg) brightness(117%) contrast(110%);  
}
.p1{
    width: 350px;
    top: 330px;
    left: -145px;
    transform: rotate(126deg);
}
.p2{
    width: 400px;
    top: 80px;
    right: -171px;
    transform: rotate(-80deg);
    
}
@media only screen and (max-width:1450px){
.aboutMe{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 80px 250px;
}
.content{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.content p{
    max-width: unset;
}
.content .here{
    width: 100%;
}
.title{
    margin: 0;
    text-align: center;
}
ul{
    width: 50%;
}
}
@media only screen and (max-width:1100px){
.aboutMe{
    padding:80px 200px
}
ul{
    width: 100%;
}
.p1{
    width: 300px;
}
.p2{
    width: 370px;
}
}
@media only screen and (max-width:950px){
.aboutMe{
    padding:80px 130px
}

ul{
    width: 50%;
    font-size: 15px;
}
.title h1{
    font-size: 40px;
}
.content p {
    font-size: 18px;
}
.p1{
    width: 260px;
}
.p2{
    width: 350px;
}

}

@media only screen and (max-width:764px){
    ul{
    width: 100%;
    }
}
@media only screen and (max-width:530px){
ul{
max-height: unset;   
}
.aboutMe{
    padding:80px 80px
}
.p1{
    width: 200px;
}
.p2{
    width: 300px;
}
}

</style>

<div class="aboutMe" id="aboutMe">
<img class="p1" src="./imgs/patterns/p1.png" alt="pattern">
<img class="p2" src="./imgs/patterns/p4.png" alt="pattern">
   
    <div class="title">
        <h1 data-aos="fade-right" data-aos-duration="1000">{{
            "en":"About me",
            "fr":"À propos de moi"
            }[$lang]}
        </h1>
        <h1 data-aos="fade-right" data-aos-duration="1000">
            {{
            "en":"more...",
            "fr":"plus ..."
            }[$lang]}
        </h1>
    </div>
    <div class="content">
        <p data-aos="fade-left" data-aos-duration="1000" data-aos-delay="100">
            {{
            "en":"Enthusiastic and motivated web developer with over 3 years of experience in full-stack Shopify development and a strong background in frontend development. I bring expertise across various IT domains, including web and mobile app development, web scraping, Python automation, and content creation. Passionate about crafting seamless user experiences and innovative solutions, I am seeking opportunities that will further refine my skills and support my growth into a Senior Full-Stack Developer",
            "fr":"Développeur web enthousiaste et motivé avec plus de 3 ans d'expérience en développement full-stack Shopify et une solide expertise en développement frontend. Je possède des compétences dans divers domaines de l'IT, notamment le développement d'applications web et mobiles, le web scraping, l'automatisation Python et la création de contenu. Passionné par la création d'expériences utilisateur fluides et de solutions innovantes, je recherche des opportunités qui me permettront de perfectionner mes compétences et de soutenir mon évolution vers un rôle de Développeur Full-Stack Senior."
            }[$lang]}
            
        </p>
        <p class="here" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="100">
            {{
                "en":"Here are a few technologies I've been working with recently:",
                "fr":"Voici quelques technologies que je travaille avec récemment:"
                }[$lang]}
            
        </p>
        <ul>
            <li data-aos="fade-left" data-aos-duration="1000">Shopify</li>
            <li data-aos="fade-left" data-aos-duration="1000" data-aos-delay="100">liquid</li>
            <li data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200" >JavaScript</li>
            <li data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">Remix</li>
            <li data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">Astro</li>
            <li data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">Svelte</li>
            <li data-aos="fade-left" data-aos-duration="1000" >HTML5 / CSS3</li>
            <li data-aos="fade-left" data-aos-duration="1000" data-aos-delay="100">Node.js</li> 
        </ul>
    </div>  

</div>